import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
// import { async } from '@angular/core/testing';

export interface PeriodicElement {
  site: string;
  application: string;
  asset: string;
  make: string;
  status:string;
  range:string;
  stops:string;
  run_time:string;
  last_service:string;
  service_performed:string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { site: 'Hydrogen', application: '1.0079', asset: 'H', make:'', status:'',range:'', stops:'', run_time:'', last_service:'', service_performed:''},
  { site: 'Hydrogen', application: '1.0079', asset: 'H', make:'', status:'',range:'', stops:'', run_time:'', last_service:'', service_performed:''},
  { site: 'Hydrogen', application: '1.0079', asset: 'H', make:'', status:'',range:'', stops:'', run_time:'', last_service:'', service_performed:''},
];

@Component({
  selector: 'app-plant-dashboard',
  templateUrl: './plant-dashboard.component.html',
  styleUrls: ['./plant-dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule,MatToolbar]
})
export class PlantDashboardComponent implements OnInit {
  public plantInfoUrl = BaseUrlConstantsService.BASE_PLANT;
  


  public breadcrumbsArray: any = [{
    page_ref: 'plant-dashboard',
    page_title: 'Plant Dashboard'
  }];
  infoForTab:any;
  dataSource:any = [];

  btnColour = '#dedede';
  btnColor2 = '#ffffff';
  public tabColor = '1day';

  showList:boolean;
  emptyMsg:boolean = true;
  public showEmptyError = 'Fetching assets, please wait..';

  constructor(
    private changeService: ChangeUsersService,
    public router: Router,
    public dialog: MatDialog,
    private service: BackendApiService,
    private activeRoute: ActivatedRoute) { 

    }



  ngOnInit() {
    this.getPlantData();
  }



  selectItem(value) {
    switch (value) {
      case '1day':
        this.tabColor = value;
        break;
      case '1week':
      
        break;
      case '1month':
     
        break;
      case '3month':
      
        break;
    }
  }




  getPlantData(){
    this.changeService.loader(true);
    this.service.getData(this.plantInfoUrl + "/" + localStorage.getItem('user_id')+'?filter=day').then(async (res) => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        if (JSON.parse(JSON.stringify(res)).data.body.length === 0) {
          this.showEmptyError = 'No Assets Available!';
          this.showList = false;
          this.emptyMsg = true;
        } else {
          this.showEmptyError = '';
          this.showList = true;
          this.emptyMsg = false;
          this.dataSource = JSON.parse(JSON.stringify(res)).data.body;
        }
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

 
  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

}
